import { Component, input } from '@angular/core';
import { ReactiveFormsModule, type FormGroup } from '@angular/forms';
import {
  CrntFormControl,
  CrntFormControlHelpText,
  CrntFormControlLabel,
  CrntTextInput,
} from '@essent/current-web-angular';
import { TrackFieldfocusDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { RfaFormControl } from '../../../level1';
import { focusChangeOptionsToConfig } from '../../helpers/tracker-options-to-config';
import type { RfaFocusChangeTrackerOptions } from '../../models/rfa-tracker-options.interface';
import type { RfaComponents } from '../RfaComponents';
import type { RfaNameControls } from '../../models/rfa-name';
import { getAriaDescribedBy } from '../../helpers/aria-fn-helpers';
import { RfaErrorsComponent } from '../utils/rfa-errors/rfa-errors.component';

@Component({
  selector: 'rfa-name',
  standalone: true,
  templateUrl: './rfa-name.component.html',
  imports: [
    ReactiveFormsModule,
    RfaErrorsComponent,
    CrntFormControl,
    CrntFormControlLabel,
    CrntTextInput,
    CrntFormControlHelpText,
    TrackFieldfocusDirective,
    AutomationIdDirective,
  ],
  styleUrls: [
    '../styles.essent.scss',
    '../styles.ed.scss',
    './rfa-name.component.scss',
  ],
})
export class RfaNameComponent {
  readonly form = input.required<FormGroup<RfaNameControls>>();

  protected readonly legendText = 'Naam';
  protected readonly initialsAutocompleteId = 'initials';
  protected readonly insertionAutocompleteId = 'insertion';
  protected readonly lastNameAutocompleteId = 'family-name';

  get initialsControl() {
    return this.form().controls.initials;
  }

  get insertionControl() {
    return this.form().controls.insertion;
  }

  get lastNameControl() {
    return this.form().controls.lastName;
  }

  focusChangeTrackConfig(
    control: RfaFormControl<string, typeof RfaComponents.TextInput>
  ) {
    const focusChangeOptions: RfaFocusChangeTrackerOptions = control.options
      .analytics?.focusChangeTracker ?? {
      fieldName: control.options.label,
    };

    return focusChangeOptionsToConfig(focusChangeOptions, {
      fieldName: control.options.label,
      hashValue: false,
    });
  }

  protected ariaDescribedBy(
    control: RfaFormControl<string, typeof RfaComponents._Any>
  ) {
    return getAriaDescribedBy(control);
  }
}
